import './App.css';
import About from "./pages/About";
import Services from "./pages/Services";
import MainNavigation from "./components/NavigationBar";
import Contact from "./pages/Contact";
import React from "react";
import Gallery from "./pages/Gallery";
import Hero from "./components/Hero";
import Persons from './pages/Persons';
import Footer from './components/Footer';

function App() {
    return (
        <div>
            <div>
                <MainNavigation/>
                <div id="content">
                    <Hero />
                    <About/>
                    <Services/>
                    <Gallery/>
                    <Persons/>
                    <Contact/>
                </div>
                <Footer />
            </div>
        </div>
    );
}

export default App;
